import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'async-apis-messages',
});

export const messageDetailSubRouteRef = createSubRouteRef({
  id: 'async-apis-messages-message-detail',
  parent: rootRouteRef,
  path: '/default/message/:messageName',
});

